/**
 * 模块名称: 工作日设置
 * @author xuzhongyuan@372163.com
 */

import React, { useState, useEffect } from 'react'
import CompanyBackup from 'components/CompanyBackup'
import Auth from '@/components/AuthMiddleware'
import api from 'api'
import { Calendar, Button, Select, message, Modal, Icon, Spin } from 'antd'
import './assets/style.scss'
import moment from 'moment'

const { Option } = Select
const year = moment().year()
const month = moment().month()
// console.log(year + '年' + month + '月')
const options = []
for (let i = year; i < year + 3; i += 1) {
  options.push(<Option key={i} value={i} className="year-item">{i}</Option>)
}

const filter = {
  corpId: '',
  year,
  month
}

const Workday = (props) => {
  const { history } = props
  const [monthWorkday, setMonthWorkday] = useState([])
  const [workdays, setWorkdays] = useState([])
  const [currentMonth, setCurrentMonth] = useState(moment())
  const [currentDate, setCurrentDate] = useState(moment())
  const [loading, setLoading] = useState(false)
  const [authList, setAuthList] = useState([])
  const [modalVisible, setModalVisible] = useState(false)

  useEffect(() => {
    filter.year = moment().year()
    filter.month = moment().month()
    api.getPageAuth().then(list => setAuthList(list))
  }, [])

  const getWorkdays = () => {
    setLoading(true)
    api.getWorkDays({
      corpId: filter.corpId,
      year: filter.year,
      month: filter.month + 1
    }).then(data => {
      setWorkdays(data)
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }

  // 获取一年中12个月的工作日
  const getMonthWorkDays = () => {
    setLoading(true)
    api.getMonthWorkDays({
      corpId: filter.corpId,
      year: filter.year
    }).then(data => {
      setMonthWorkday(data)
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }

  const onChangeCorp = data => {
    if(data && data.id){
      filter.corpId = data.id
      getMonthWorkDays()
      getWorkdays()
    }else{
      message.error('没有所属公司权限！')
      const timer = setTimeout(() => {
        history.push('/index')
        clearTimeout(timer)
      }, 1000)
    }
  }

  const headerRender = ({ value, type, onChange }) => {
    return (
      <div className="calendar-header">
        <Select
          size="small"
          style={{ width: 120 }}
          dropdownMatchSelectWidth={false}
          defaultValue={year}
          onChange={newYear => {
            // console.log('newYear ==>', newYear)
            filter.year = newYear
            filter.month = 0
            getMonthWorkDays()
            getWorkdays()
            setCurrentMonth(moment(newYear + '-01-01'))
            setCurrentDate(moment(newYear + '-01-01'))
          }}
        >
          {options}
        </Select>
      </div>
    )
  }

  const monthCellRender = value => {
    if (monthWorkday.length) {
      return <span className="workday-count">共{monthWorkday[value.month()].count}工作日</span>
    }
    return null
  }

  // 月份切换
  const onSelectMonthCalendar = date => {
    //console.log(date.year(), date.month())
    filter.month = date.month()
    setLoading(true)
    setCurrentMonth(date)
    setCurrentDate(date)
    getWorkdays()
  }

  // 工作日状态切换
  const onClickDateCell = (date, type) => {
    // console.log(date, type)
    if(!authList.includes('operate'))return message.warning('您没有设置工作日的权限')
    let nextType = ''
    if (type === 'weekday') {
      nextType = 'dayOff'
    } else if (type === 'dayOff') {
      nextType = 'holiday'
    } else if (type === 'holiday') {
      nextType = 'weekday'
    } else {
      // 兼容旧版本，根据status切换
      nextType = type ? 'dayOff' : 'weekday'
    }
    setLoading(true)
    api.setWorkday({
      corpId: filter.corpId,
      date: date,
      type: nextType
    }).then(() => {
      getWorkdays()
      setMonthWorkday(monthWorkday.map(item => {
        if (date.includes(item.month)) {
          let countChange = 0
          // 从工作日变为其他状态，工作日数-1
          if (type === 'weekday') {
            countChange = -1
          }
          // 从其他状态变为工作日，工作日数+1
          else if (nextType === 'weekday') {
            countChange = 1
          }
          return { ...item, count: item.count + countChange }
        }
        return item
      }))
    }).catch(() => {
      setLoading(false)
    })
  }

  const dateCellRender = (value) => {
    // console.log('value ==>', value.format('YYYY-MM-DD'))
    // console.log('value month ==>', value.month())
    // console.log('filter month ==>', filter.month)

    if (workdays.length === 0) {
      return null
    }

    if (value.month() === filter.month) {
      const date = value.format('YYYY-MM-DD')
      const day = workdays.find(item => item.date === date)
      if (day) {
        // 根据type确定类名
        let cellClassName = 'vacation-day'
        if (day.type) {
          if (day.type === 'weekday') {
            cellClassName = 'work-day'
          } else if (day.type === 'holiday') {
            cellClassName = 'holiday-day'
          }
        } else {
          // 兼容旧版本使用status
          cellClassName = day.status ? 'work-day' : 'vacation-day'
        }
        
        return (
          <span
            onClick={() => onClickDateCell(date, day.type || day.status)}
            className={`date-cell ${cellClassName}`}
          >
            {value.date()}
          </span>
        )
      }
    } else {
      return <span className="date-cell disabled">{value.date()}</span>
    }
    return null
  }

  const onSetAll = () => {
    setLoading(true)
    api.setAllWorkDay({ corpId: filter.corpId, year: filter.year }).then(() => {
      message.success('设置成功')
      setLoading(false)
      setModalVisible(false)
    }).catch(() => {
      setLoading(false)
      setModalVisible(false)
    })
  }

  return (
    <>
      <CompanyBackup onChange={onChangeCorp} radio notHeadOffice />
      <div className="calendar-tags">
        <span className="workday-tag">工作日</span>
        <span className="playday-tag">休息日</span>
        <span className="holiday-tag">法定节假日</span>
      </div>
      <Spin spinning={loading} tip="加载中...">
        <div className="calender-wrap">
          <div className="calendar-month">
            <Calendar
              mode="year"
              headerRender={headerRender}
              monthCellRender={monthCellRender}
              onSelect={onSelectMonthCalendar}
              value={currentMonth}
            />
            <div className="calendar-btn">
              <Auth auths={authList} code="workday-push-all">
                <Button type="primary" onClick={() => setModalVisible(true)}>将今年设置推广至全公司</Button>
              </Auth>
            </div>
          </div>

          <div className="calendar-days">
            <Calendar
              value={currentDate}
              headerRender={() => null}
              dateFullCellRender={dateCellRender}
            />
          </div>
        </div>
      </Spin>
      <Modal
        title={<><Icon type="info-circle" style={{color: '#faad14', fontSize: '17px'}} /> 请注意！</>}
        visible={modalVisible}
        onOk={onSetAll}
        onCancel={() => setModalVisible(false)}
        okText="继续提交"
        cancelText="返回修改"
      >
        此次操作将对所有公司已设置工作日进行覆盖操作，请谨慎操作！
      </Modal>
    </>
  )
}

export default Workday